"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsApi = void 0;
const env_1 = require("../../conf/env");
const base_api_1 = require("./base-api");
/**
 * @description api services for analytics api endpoints
 *
 * @export
 * @class AnalyticsApi
 * @extends {BaseApi<T>}
 * @template T
 */
class AnalyticsApi extends base_api_1.BaseApi {
    constructor() {
        const axiosConfig = {
            baseURL: env_1.ANALYTICS_API_URL,
            timeout: 7000
        };
        super(axiosConfig);
    }
}
exports.AnalyticsApi = AnalyticsApi;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYW5hbHl0aWNzQXBpLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3ByaXZhdGUvYXBpLXNlcnZpY2VzL2FuYWx5dGljc0FwaS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSx3Q0FBa0Q7QUFDbEQseUNBQXFDO0FBRXJDOzs7Ozs7O0dBT0c7QUFDSCxNQUFhLFlBQWdCLFNBQVEsa0JBQVU7SUFFN0M7UUFDRSxNQUFNLFdBQVcsR0FBdUI7WUFDdEMsT0FBTyxFQUFFLHVCQUFpQjtZQUMxQixPQUFPLEVBQUUsSUFBSTtTQUNkLENBQUM7UUFFRixLQUFLLENBQUMsV0FBVyxDQUFDLENBQUM7SUFDckIsQ0FBQztDQUVGO0FBWEQsb0NBV0MifQ==